import React, { Component } from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import axios from "axios";
import { InlineNotification } from "carbon-components-react";
import { connect } from "react-redux";
import { Navigate, Redirect } from "react-router-dom";

import ExecutionEnvironment from "exenv";
import { restHostBackend } from "../config";

const mapStateToProps = (reduxStore) => ({ auth: reduxStore.auth });

class ForgotPasswordForm extends Component {
  state = {
    loading: false,
    error: "",
    success: false,
  };

  handleSubmit = (values, actions) => {
    this.setState({
      loading: true,
      error: "",
    });

    /* todo @David removed {self}. is this importend for security? Why not Backend URL? */
    axios
      .post(
        `${restHostBackend}/user/lost-password?_format=json`,
        {
          mail: values.email,
        },
        {
          headers: {
            "Content-type": "application/json",
          },
          withCredentials: false,
        }
      )
      .then((response) => {
        console.log(response.data);
        this.setState({ success: true });
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          error: error.response.data.message,
        });
      })
      .then(() => {
        actions.setSubmitting(false);
      });
  };

  render() {

    if (
      this.props.auth.userLoginData.logout_token &&
      ExecutionEnvironment.canUseDOM
    ) {
      return <Navigate to="/intern" />;
    }

    return (
      <div className="container">
        <div className="login-wrapper row">
          <div className="col-9 col-md-5 offset-md-2">
            {this.state.success && (
              <InlineNotification
                kind="success"
                title="Erfolgreich!"
                subtitle="Es wurde eine E-Mail mit weiterern Anweisungen verschickt."
              />
            )}
            {!this.state.success && this.state.error !== "" && (
              <InlineNotification
                kind="error"
                title="Authentication Error"
                subtitle={this.state.error}
              />
            )}
            <h2>Passwort zurücksetzen</h2>
            <Formik
              onSubmit={(values, actions) => {
                this.handleSubmit(values, actions);
              }}
              initialValues={{
                email: "",
              }}
              validationSchema={yup.object().shape({
                email: yup
                  .string()
                  //.email()
                  .required(),
              })}
              className="form-container"
            >
              <Form>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Field
                    type="text"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                  />
                  <ErrorMessage name="email" />
                </div>
                <button type="submit" className="btn btn-primary">
                  Passwort zurücksetzen
                </button>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPasswordForm.propTypes = {
  auth: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ForgotPasswordForm);
